import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Input,
  Table,
  Spinner,
} from "reactstrap"
import Select from "react-select"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withRouter } from "react-router-dom"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import ButtonSpinner from "components/ButtonSpinner"
import * as productAction from "../../../store/ZmxyUGVuZGluZ0/actions"
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"
import moment from "moment"
import "./styles.scss"
import api from "helpers/Api"
import ReactDOM from "react-dom"
import FlrPendingDataReportTab from "./FlrPendingDataReportTab"

const FlrPendingDataReport = (props) => {
  const { searchBtnStyle, dispatch } = props
  const title = "FLR Pending Data Report"
  const [productStatusData, setProductStatusData] = useState({
    eventFromDate: "",
    eventToDate: "",
  })
  //Fetching API
  useEffect(() => {
    dispatch(productAction.loadProductStatus())
    dispatch(productAction.loadRecordsMetaData())
  }, [])

  //date format
  const update = useSelector(
    (specificstate) => specificstate.flrPendingDataReport
  )

  //product_data
  const { recordsMetaData = {}, product_data = [] } = update
  console.log(update, "recordsMetaData")

  const [freelancerName, setFreelancerName] = useState([])
  //Date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate

  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []
  const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  const handleChange = (e) => {
    setProductStatusData({
      ...productStatusData,
      [e.target.name]: e.target.value,
    })
  }

  const [downloadLoading, setDownloadLoading] = useState(false)

  //Search value

  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const [btnLoader, setBtnLoader] = useState(false)
  const [searchValue, setSearchValue] = useState({})
  console.log(dateFormat)
  console.log(searchValue)
  const handleFilter = (e) => {
    e.preventDefault()

    var searchFreelancer =
      !isEmpty(freelancerName) && freelancerName ? freelancerName.value : ""
    var searchFromDate =
      productStatusData && productStatusData.eventFromDate
        ? moment(productStatusData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      productStatusData && productStatusData.eventToDate
        ? moment(productStatusData.eventToDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}

    if (searchFreelancer) {
      searchvalue.freelancerNameId = searchFreelancer
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    setSearchValue(searchvalue)
    dispatch(productAction.loadProductStatus(searchvalue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 3000)
  }

  //reset

  const resetForm = () => {
    setSearchInput("")
    setFreelancerName([])
    setProductStatusData({
      ...productStatusData,
      eventFromDate: "",
      eventToDate: "",
    })
    dispatch(productAction.loadProductStatus())
  }

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      productAction.loadProductStatus({
        searchFilter: searchInput,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }
  //

  const handleClickTab = (tableData) => {
    const statusName = tableData.serviceName
    let statusDetails = {
      freelancerNameId: tableData.freelancerNameId,
      serviceName:tableData.serviceName
    }


    api
      .post(`/freelancer_pending_data_copy_report_details`, statusDetails)
      .then((response) => {
        const statusData = !isEmpty(response.data.data)
          ? response.data.data
          : []
        setTimeout(() => {
          // Use the current value of statusData, which should be updated due to the useEffect

          const newTab = window.open("", "_blank", "width=600,height=400")
          if (newTab) {
            const container = newTab.document.createElement("div")
            newTab.document.body.appendChild(container)
            ReactDOM.render(
              <FlrPendingDataReportTab
                data={statusData} // Use statusData directly here
                dispatch={dispatch}
                statusPayload={statusDetails}
                name={statusName}
                dateFormat={dateFormat}
              />,
              container
            )
            newTab.document.title = "EVENT-MONTH-WISE-PRODUCT-STATUS-REPORT"
          }
        }, 2000)
      })
      .catch((error) => {
        Promise.reject(error)
        const newTab = window.open("", "_blank", "width=600,height=400")
        if (newTab) {
          const container = newTab.document.createElement("div")
          newTab.document.body.appendChild(container)
          ReactDOM.render(
            <FlrPendingDataReportTab
              //data={statusData} // Use statusData directly here
              dispatch={dispatch}
              statusPayload={statusDetails}
              name={statusName}
              dateFormat={dateFormat}
            />,
            container
          )
          newTab.document.title = "FLR-PENDING-DATA-REPORT"
        }
      })
  }

  const exportToCsv = () => {
    setDownloadLoading(true)
    var searchFreelancer =
      !isEmpty(freelancerName) && freelancerName ? freelancerName.value : ""
    var searchFromDate =
      productStatusData && productStatusData.eventFromDate
        ? moment(productStatusData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      productStatusData && productStatusData.eventToDate
        ? moment(productStatusData.eventToDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}

    if (searchFreelancer) {
      searchvalue.freelancerNameId = searchFreelancer
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }

    api
      .post(`/freelancer_pending_data_copy_report`, searchvalue)
      .then((response) => {
        const product_data = !isEmpty(response.data.data)
          ? response.data.data
          : []
        //table
        const ExportDataTable = product_data.map((data, index) => {
          const services = data.services || {}

          // Retrieve event dates and format them
          const tpEventDate =
            services["TRADITIONAL PHOTOGRAPHY"]?.eventDate || ""
          const tpEventDateValue = tpEventDate
            ? moment(tpEventDate).format("YYYY-MM-DD")
            : "--"

          const cpEventDate = services["CANDID PHOTOGRAPHY"]?.eventDate || ""
          const cpEventDateValue = cpEventDate
            ? moment(cpEventDate).format("YYYY-MM-DD")
            : "--"

          const tvEventDate =
            services["TRADITIONAL VIDEOGRAPHY"]?.eventDate || ""
          const tvEventDateValue = tvEventDate
            ? moment(tvEventDate).format("YYYY-MM-DD")
            : "--"

          const cEventDate = services["CINEMATOGRAPHY"]?.eventDate || ""
          const cEventDateValue = cEventDate
            ? moment(cEventDate).format("YYYY-MM-DD")
            : "--"

          const hEventDate = services["HELICAM"]?.eventDate || ""
          const hEventDateValue = hEventDate
            ? moment(hEventDate).format("YYYY-MM-DD")
            : "--"

          const muEventDate = services["MIXER UNIT"]?.eventDate || ""
          const muEventDateValue = muEventDate
            ? moment(muEventDate).format("YYYY-MM-DD")
            : "--"

          const lsEventDate = services["LIVE STREAMING"]?.eventDate || ""
          const lsEventDateValue = lsEventDate
            ? moment(lsEventDate).format("YYYY-MM-DD")
            : "--"

          // Service counts
          const tpCount = services["TRADITIONAL PHOTOGRAPHY"]?.count || 0
          const cpCount = services["CANDID PHOTOGRAPHY"]?.count || 0
          const tvCount = services["TRADITIONAL VIDEOGRAPHY"]?.count || 0
          const cCount = services["CINEMATOGRAPHY"]?.count || 0
          const hCount = services["HELICAM"]?.count || 0
          const muCount = services["MIXER UNIT"]?.count || 0
          const lsCount = services["LIVE STREAMING"]?.count || 0

          const rowTotal =
            tpCount + cpCount + tvCount + cCount + hCount + muCount + lsCount
          const count = rowTotal // Overall count for the row

          return {
            sNo: index + 1,
            freelancerName: data.freelancerName || "--",
            tpCount,
            tpEventDateValue,
            cpCount,
            cpEventDateValue,
            tvCount,
            tvEventDateValue,
            cCount,
            cEventDateValue,
            hCount,
            hEventDateValue,
            muCount,
            muEventDateValue,
            lsCount,
            lsEventDateValue,
            rowTotal,
            count,
          }
        })

        // Column wise totals
        const columnTotals = {
          tpCount: product_data.reduce(
            (sum, data) =>
              sum + (data.services?.["TRADITIONAL PHOTOGRAPHY"]?.count || 0),
            0
          ),
          cpCount: product_data.reduce(
            (sum, data) =>
              sum + (data.services?.["CANDID PHOTOGRAPHY"]?.count || 0),
            0
          ),
          tvCount: product_data.reduce(
            (sum, data) =>
              sum + (data.services?.["TRADITIONAL VIDEOGRAPHY"]?.count || 0),
            0
          ),
          cCount: product_data.reduce(
            (sum, data) =>
              sum + (data.services?.["CINEMATOGRAPHY"]?.count || 0),
            0
          ),
          hCount: product_data.reduce(
            (sum, data) => sum + (data.services?.["HELICAM"]?.count || 0),
            0
          ),
          muCount: product_data.reduce(
            (sum, data) => sum + (data.services?.["MIXER UNIT"]?.count || 0),
            0
          ),
          lsCount: product_data.reduce(
            (sum, data) =>
              sum + (data.services?.["LIVE STREAMING"]?.count || 0),
            0
          ),
        }

        columnTotals.total = Object.values(columnTotals).reduce(
          (sum, value) => sum + value,
          0
        )
        setTimeout(() => {
          // first and second row
          let headerData = [
            "#,Traditional Photography, ,Candid Photography, ,Traditional Videography, ,Cinematography, ,Helicam, ,Mixer Unit, ,Live Streaming, ,Total", // First row header
            "FLR Name,Count,Oldest Event Date,Count,Oldest Event Date,Count,Oldest Event Date,Count,Oldest Event Date,Count,Oldest Event Date,Count,Oldest Event Date,Count,Oldest Event Date,Total ,", // Second row header
          ]

          // Data rows
          let csvRows = ExportDataTable.map((row) => {
            return [
              row.freelancerName,
              row.tpCount,
              row.tpEventDateValue,
              row.cpCount,
              row.cpEventDateValue,
              row.tvCount,
              row.tvEventDateValue,
              row.cCount,
              row.cEventDateValue,
              row.hCount,
              row.hEventDateValue,
              row.muCount,
              row.muEventDateValue,
              row.lsCount,
              row.lsEventDateValue,
              row.rowTotal,
              // Corrected to avoid extra unwanted column
            ].join(",")
          })

          // Add total row
          csvRows.push(
            [
              "Total",
              columnTotals.tpCount,
              "",
              columnTotals.cpCount,
              "",
              columnTotals.tvCount,
              "",
              columnTotals.cCount,
              "",
              columnTotals.hCount,
              "",
              columnTotals.muCount,
              "",
              columnTotals.lsCount,
              "",
              columnTotals.total,
              "", // No total for Count
            ].join(",")
          )

          // Combine header and data into CSV content
          const csvContent = [...headerData, ...csvRows].join("\n")

          // Trigger the file download
          downloadFile({
            data: csvContent,
            fileName: "FreelancerServicesReport.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 1500)
        return response.data
      })
      .catch((error) => {
        setDownloadLoading(false)
        Promise.reject(error)
      })
  }

  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"Reports"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Event From Date"}
                        >
                          {"Event From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="eventFromDate"
                        value={productStatusData.eventFromDate}
                        max={productStatusData.eventToDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Event To Date"}
                        >
                          {"Event To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="eventToDate"
                        value={productStatusData.eventToDate}
                        min={productStatusData.eventFromDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Freelancer Name"}
                        >
                          {"Freelancer Name"}
                        </Label>
                      </div>

                      <Select
                        type="text"
                        options={recordsMetaData.freelancerOptions}
                        value={freelancerName}
                        name="freelancerName"
                        placeholder="Select Freelancer Name"
                        onChange={(e) => setFreelancerName(e)}
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                          onClick={() => {
                            resetForm()
                          }}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          onClick={(e) => handleFilter(e)}
                          className="btn btn-success btn-label simple-form-applyfilter-btn"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md="12" lg="12" xl="12">
            <Card>
              <CardBody>
                <div className="d-flex flex-row" style={{ marginTop: "20px" }}>
                  <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                    <form onSubmit={handleClick} className="d-flex flex-row">
                      <div style={searchBtnStyle || null}>
                        <Input
                          type="text"
                          name="searchInput"
                          value={searchInput}
                          onChange={(e) => setSearchInput(e.target.value)}
                          className="form-control"
                          placeholder="Search"
                          style={{ position: "relative" }}
                        />
                        <i
                          className="bx bx-search-alt"
                          style={{
                            position: "absolute",
                            top: "54px",
                            left: "41px",
                            fontSize: "13px",
                          }}
                        />
                      </div>

                      <button
                        className="btn btn-success mx-2"
                        type="submit"
                        style={{
                          background: searchFilter ? "#2ca67a" : "",
                          color: searchFilter ? "#ffffff" : "",
                        }}
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </form>
                  </div>
                </div>
                <Row>
                  <Col md="4" lg="4" sm="12"></Col>
                  <Col
                    md="8"
                    lg="8"
                    sm="12"
                    style={{ marginBottom: "20px", marginTop: "-41px" }}
                  >
                    <div
                      style={{
                        float: "right",
                      }}
                    >
                      <Button
                        className="btn btn-primary"
                        onClick={exportToCsv}
                        id="download"
                        style={{
                          backgroundColor: "#e40d8c",
                          color: "white",
                          border: "none",
                        }}
                      >
                        Download
                      </Button>
                    </div>
                  </Col>
                </Row>

                <Col md="12" lg="12" xl="12" className="mt-3">
                  <Table responsive bordered>
                    <thead>
                      <tr>
                        <th
                          colSpan={1}
                          style={{
                            minWidth: "150px",
                            position: "sticky",
                            left: 0,
                            zIndex: 1,
                            backgroundColor: "#F8F8FB",
                          }}
                        >
                          {" "}
                          #{" "}
                        </th>
                        <th colSpan={2} style={{ minWidth: "250px" }}>
                          Traditional Photography
                        </th>
                        <th colSpan={2} style={{ minWidth: "250px" }}>
                          Candid Photography
                        </th>
                        <th colSpan={2} style={{ minWidth: "250px" }}>
                          Traditional Videography
                        </th>
                        <th colSpan={2} style={{ minWidth: "250px" }}>
                          Cinematography
                        </th>
                        <th colSpan={2} style={{ minWidth: "250px" }}>
                          Helicam
                        </th>
                        <th colSpan={2} style={{ minWidth: "250px" }}>
                          Mixer Unit
                        </th>
                        <th colSpan={2} style={{ minWidth: "250px" }}>
                          Live Streaming
                        </th>
                        <th colSpan={1} style={{ minWidth: "150px" }}>
                          Total
                        </th>
                      </tr>
                      <tr>
                        <th
                          style={{
                            minWidth: "150px",
                            position: "sticky",
                            left: 0,
                            zIndex: 1,
                            backgroundColor: "#F8F8FB",
                          }}
                        >
                          FLR Name
                        </th>
                        <th style={{ minWidth: "100px" }}>Count</th>
                        <th style={{ minWidth: "150px" }}>Oldest Event Date</th>
                        <th style={{ minWidth: "100px" }}>Count</th>
                        <th style={{ minWidth: "150px" }}>Oldest Event Date</th>
                        <th style={{ minWidth: "100px" }}>Count</th>
                        <th style={{ minWidth: "150px" }}>Oldest Event Date</th>
                        <th style={{ minWidth: "100px" }}>Count</th>
                        <th style={{ minWidth: "150px" }}>Oldest Event Date</th>
                        <th style={{ minWidth: "100px" }}>Count</th>
                        <th style={{ minWidth: "150px" }}>Oldest Event Date</th>
                        <th style={{ minWidth: "100px" }}>Count</th>
                        <th style={{ minWidth: "150px" }}>Oldest Event Date</th>
                        <th style={{ minWidth: "100px" }}>Count</th>
                        <th style={{ minWidth: "150px" }}>Oldest Event Date</th>
                        <th style={{ minWidth: "150px" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {product_data && product_data.length > 0 ? (
                        product_data.map((data, index) => {
                          const services = data?.services || {}

                          const tpCount = services["TRADITIONAL PHOTOGRAPHY"]
                            ? services["TRADITIONAL PHOTOGRAPHY"].count
                            : 0
                          const tpEventDate = services[
                            "TRADITIONAL PHOTOGRAPHY"
                          ]
                            ? services["TRADITIONAL PHOTOGRAPHY"].eventDate
                            : ""
                          const tpEventDateValue = tpEventDate
                            ? moment(tpEventDate).format(dateFormat)
                            : "--"
                          const tpData = {
                            freelancerNameId: data.frelancerId,
                            serviceName: "TRADITIONAL PHOTOGRAPHY",
                          }

                          const cpCount = services["CANDID PHOTOGRAPHY"]
                            ? services["CANDID PHOTOGRAPHY"].count
                            : 0
                          const cpEventDate = services["CANDID PHOTOGRAPHY"]
                            ? services["CANDID PHOTOGRAPHY"].eventDate
                            : ""
                          const cpEventDateValue = cpEventDate
                            ? moment(cpEventDate).format(dateFormat)
                            : "--"
                          const cpData = {
                            freelancerNameId: data.frelancerId,
                            serviceName: "CANDID PHOTOGRAPHY",
                          }

                          const tvCount = services["TRADITIONAL VIDEOGRAPHY"]
                            ? services["TRADITIONAL VIDEOGRAPHY"].count
                            : 0
                          const tvEventDate = services[
                            "TRADITIONAL VIDEOGRAPHY"
                          ]
                            ? services["TRADITIONAL VIDEOGRAPHY"].eventDate
                            : ""
                          const tvEventDateValue = tvEventDate
                            ? moment(tvEventDate).format(dateFormat)
                            : "--"
                          const tvData = {
                            freelancerNameId: data.frelancerId,
                            serviceName: "TRADITIONAL VIDEOGRAPHY",
                          }

                          const cCount = services["CINEMATOGRAPHY"]
                            ? services["CINEMATOGRAPHY"].count
                            : 0
                          const cEventDate = services["CINEMATOGRAPHY"]
                            ? services["CINEMATOGRAPHY"].eventDate
                            : ""
                          const cEventDateValue = cEventDate
                            ? moment(cEventDate).format(dateFormat)
                            : "--"
                          const cData = {
                            freelancerNameId: data.frelancerId,
                            serviceName: "CINEMATOGRAPHY",
                          }

                          const hCount = services["HELICAM"]
                            ? services["HELICAM"].count
                            : 0
                          const hEventDate = services["HELICAM"]
                            ? services["HELICAM"].eventDate
                            : ""
                          const hEventDateValue = hEventDate
                            ? moment(hEventDate).format(dateFormat)
                            : "--"
                          const hData = {
                            freelancerNameId: data.frelancerId,
                            serviceName: "HELICAM",
                          }

                          const muCount = services["MIXER UNIT"]
                            ? services["MIXER UNIT"].count
                            : 0
                          const muEventDate = services["MIXER UNIT"]
                            ? services["MIXER UNIT"].eventDate
                            : ""
                          const muEventDateValue = muEventDate
                            ? moment(muEventDate).format(dateFormat)
                            : "--"
                          const muData = {
                            freelancerNameId: data.frelancerId,
                            serviceName: "MIXER UNIT",
                          }

                          const lsCount = services["LIVE STREAMING"]
                            ? services["LIVE STREAMING"].count
                            : 0
                          const lsEventDate = services["LIVE STREAMING"]
                            ? services["LIVE STREAMING"].eventDate
                            : ""
                          const lsEventDateValue = lsEventDate
                            ? moment(lsEventDate).format(dateFormat)
                            : "--"
                          const lsData = {
                            freelancerNameId: data.frelancerId,
                            serviceName: "LIVE STREAMING",
                          }
                          const rowTotal =
                            tpCount +
                            cpCount +
                            tvCount +
                            cCount +
                            hCount +
                            muCount +
                            lsCount
                          return (
                            <>
                              <tr key={index}>
                                <th
                                  scope="row"
                                  style={{
                                    minWidth: "150px",
                                    position: "sticky",
                                    left: 0,
                                    zIndex: 1,
                                    backgroundColor: "#F8F8FB",
                                  }}
                                >
                                  {data.freelancerName || "--"}
                                </th>
                                <td
                                  style={{
                                    textAlign: "center",
                                    minWidth: "100px",
                                    color: "#e40d8c",
                                    textDecoration: "underline",
                                  }}
                                  onClick={() => handleClickTab(tpData)}
                                >
                                  {tpCount}
                                </td>
                                <td>{tpEventDateValue}</td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    minWidth: "100px",
                                    color: "#e40d8c",
                                    textDecoration: "underline",
                                  }}
                                  onClick={() => handleClickTab(cpData)}
                                >
                                  {cpCount}
                                </td>
                                <td>{cpEventDateValue}</td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    minWidth: "100px",
                                    color: "#e40d8c",
                                    textDecoration: "underline",
                                  }}
                                  onClick={() => handleClickTab(tvData)}
                                >
                                  {tvCount}
                                </td>
                                <td>{tvEventDateValue}</td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    minWidth: "100px",
                                    color: "#e40d8c",
                                    textDecoration: "underline",
                                  }}
                                  onClick={() => handleClickTab(cData)}
                                >
                                  {cCount}
                                </td>
                                <td>{cEventDateValue}</td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    minWidth: "100px",
                                    color: "#e40d8c",
                                    textDecoration: "underline",
                                  }}
                                  onClick={() => handleClickTab(hData)}
                                >
                                  {hCount}
                                </td>
                                <td>{hEventDateValue}</td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    minWidth: "100px",
                                    color: "#e40d8c",
                                    textDecoration: "underline",
                                  }}
                                  onClick={() => handleClickTab(muData)}
                                >
                                  {muCount}
                                </td>
                                <td>{muEventDateValue}</td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    minWidth: "100px",
                                    color: "#e40d8c",
                                    textDecoration: "underline",
                                  }}
                                  onClick={() => handleClickTab(lsData)}
                                >
                                  {lsCount}
                                </td>
                                <td>{lsEventDateValue}</td>
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    textAlign: "center",
                                  }}
                                >
                                  {rowTotal}
                                </td>
                              </tr>
                            </>
                          )
                        })
                      ) : (
                        <tr>
                          <td className="text-align-center" colSpan={15}>
                            No Results Found
                          </td>
                        </tr>
                      )}
                      <tr>
                        <th
                          style={{
                            minWidth: "150px",
                            position: "sticky",
                            left: 0,
                            zIndex: 1,
                            backgroundColor: "#F8F8FB",
                          }}
                        >
                          Total
                        </th>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce(
                            (sum, data) =>
                              sum +
                              (data?.services?.["TRADITIONAL PHOTOGRAPHY"]
                                ? data.services["TRADITIONAL PHOTOGRAPHY"].count
                                : 0),
                            0
                          )}
                        </td>
                        <td></td>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce(
                            (sum, data) =>
                              sum +
                              (data?.services?.["CANDID PHOTOGRAPHY"]
                                ? data.services["CANDID PHOTOGRAPHY"].count
                                : 0),
                            0
                          )}
                        </td>
                        <td></td>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce(
                            (sum, data) =>
                              sum +
                              (data?.services?.["TRADITIONAL VIDEOGRAPHY"]
                                ? data.services["TRADITIONAL VIDEOGRAPHY"].count
                                : 0),
                            0
                          )}
                        </td>
                        <td></td>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce(
                            (sum, data) =>
                              sum +
                              (data?.services?.["CINEMATOGRAPHY"]
                                ? data.services["CINEMATOGRAPHY"].count
                                : 0),
                            0
                          )}
                        </td>
                        <td></td>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce(
                            (sum, data) =>
                              sum +
                              (data?.services?.["HELICAM"]
                                ? data.services["HELICAM"].count
                                : 0),
                            0
                          )}
                        </td>
                        <td></td>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce(
                            (sum, data) =>
                              sum +
                              (data?.services?.["MIXER UNIT"]
                                ? data.services["MIXER UNIT"].count
                                : 0),
                            0
                          )}
                        </td>
                        <td></td>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce(
                            (sum, data) =>
                              sum +
                              (data?.services?.["LIVE STREAMING"]
                                ? data.services["LIVE STREAMING"].count
                                : 0),
                            0
                          )}
                        </td>
                        <td></td>

                        <td
                          style={{
                            fontWeight: "bold",
                            textAlign: "center",
                            color: "#000",
                          }}
                        >
                          {product_data.reduce((sum, data) => {
                            const services = data?.services || {}
                            const rowTotal =
                              (services["TRADITIONAL PHOTOGRAPHY"]
                                ? services["TRADITIONAL PHOTOGRAPHY"].count
                                : 0) +
                              (services["CANDID PHOTOGRAPHY"]
                                ? services["CANDID PHOTOGRAPHY"].count
                                : 0) +
                              (services["TRADITIONAL VIDEOGRAPHY"]
                                ? services["TRADITIONAL VIDEOGRAPHY"].count
                                : 0) +
                              (services["CINEMATOGRAPHY"]
                                ? services["CINEMATOGRAPHY"].count
                                : 0) +
                              (services["HELICAM"]
                                ? services["HELICAM"].count
                                : 0) +
                              (services["MIXER UNIT"]
                                ? services["MIXER UNIT"].count
                                : 0) +
                              (services["LIVE STREAMING"]
                                ? services["LIVE STREAMING"].count
                                : 0)
                            return sum + rowTotal
                          }, 0)}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <div className="font-size-14 mt-2">
                    <p>
                      {" "}
                      <p>{`Showing rows ${
                        product_data && product_data.length > 0 ? 1 : 0
                      } to ${
                        product_data && product_data.length > 0
                          ? product_data.length
                          : 0
                      } of ${
                        product_data && product_data.length > 0
                          ? product_data.length
                          : 0
                      }`}</p>
                    </p>
                  </div>
                </Col>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {downloadLoading ? (
        <Modal
          show={downloadLoading}
          style={{ width: "7%", margin: "18% 50%" }}
        >
          <Modal.Body>
            <Spinner
              as="span"
              animation="grow"
              size="lg"
              role="status"
              aria-hidden="true"
              variant="success"
              className="mx-2"
              color="success"
            />
          </Modal.Body>
        </Modal>
      ) : (
        ""
      )}
    </div>
  )
}
FlrPendingDataReport.propTypes = {
  dispatch: PropTypes.func,
  searchBtnStyle: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,FlrPendingDataReport
})
//FlrPendingDataReport
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FlrPendingDataReport)
)
